import { LegacyExamRequestStatus } from './enums';

const listAttributes = [
  'requestId',
  'creationDatetime',
  'dueDatetime',
  'examSubject',
  'examId',
  'examLabel',
  'fileName',
  'marker',
  'markerName',
  'status',
  'student',
  'studentName',
] as const;

const getAttributes = [...listAttributes] as const;

const updateAttributes = [
  'examSubject',
  'examId',
  'examLabel',
  'marker',
  'markerName',
  'student',
  'studentName',
  'dueDatetime',
  'status',
] as const;

export const LegacyExamMarkingRequestAttributes = {
  List: listAttributes,
  Get: getAttributes,
  Update: updateAttributes,
};

export const LEGACY_EXAM_REQUEST_STATUSES = [
  {
    key: LegacyExamRequestStatus.PendingApproval,
    value: LegacyExamRequestStatus.PendingApproval,
    label: 'Pending Approval',
  },
  {
    key: LegacyExamRequestStatus.PendingAcceptance,
    value: LegacyExamRequestStatus.PendingAcceptance,
    label: 'Pending Acceptance',
  },
  {
    key: LegacyExamRequestStatus.PendingReassignment,
    value: LegacyExamRequestStatus.PendingReassignment,
    label: 'Pending Reassignment',
  },
];

export const MAX_LEGACY_EXAM_SCAN_UPLOADS = 50;
